import { Layout as AntLayout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';
import React from 'react';

import { Content } from './Content';
import { Footer } from './Footer';
import { Header } from './Header';
import { Sider } from './Sider';

export interface ILayoutProps extends LayoutProps {}

type TLayout = React.FC<ILayoutProps> & {
  Content: typeof Content;
  Footer: typeof Footer;
  Header: typeof Header;
  Sider: typeof Sider;
};

/**
 * Layout component
 */
export const Layout: TLayout = (props) => <AntLayout {...props} />;

Layout.Content = Content;
Layout.Footer = Footer;
Layout.Header = Header;
Layout.Sider = Sider;
